import { triggerTracking } from '@zoopla/tracking';

export function trackOnChange(id: string) {
    const eventLabelOptions: { [key: string]: string } = {
        newest_listings: 'sort_most_recent',
        highest_price: 'sort_highest_price',
        lowest_price: 'sort_lowest_price',
        most_reduced: 'sort_most_reduced',
        recommended: 'sort_recommended'
    };

    const eventLabel = eventLabelOptions[id];

    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'click',
        eventLabel: eventLabel
    });
}
